const iconDefault = {
  id: 0,
  name: "",
  imageURL: "https://fakeimg.pl/50x50/"
};

export default class Icon {
  public readonly id: number;
  public readonly name: string;
  public readonly imageURL: string;

  public constructor(params: Icon = iconDefault) {
    this.id = params.id;
    this.name = params.name;
    this.imageURL = params.imageURL;
  }
}
